import React from 'react';
import './Header.scss';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useLocation } from "react-router-dom";

function Header() {

  const location = useLocation(); 

  const isActive = (path) => location.pathname === path;

  return (

    <Navbar expand="lg" className='navbar' variant="dark">
      <Container>
        {/* Logo */}
        <Navbar.Brand href="/">
          <img
            src="/img/pokelu.webp"
            alt="Logo Pokélu"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {/* Menus alignés à gauche */}
          <Nav className="me-auto">
            <Nav.Link
              href="/"
              className={isActive("/") ? "active-link" : "text-light"}
            >
              Accueil
            </Nav.Link>
            <NavDropdown
              title="Mes prestations"
              id="basic-nav-dropdown"
              menuVariant="dark"
              className={isActive("/remplacement-elevage") || isActive("/bilan-comportemental-chiens-chats") || isActive("/cours-education-chiens-chats") ? "dropdown-active text-light" : "text-light"}
            >
              <NavDropdown.Item
                href="/remplacement-elevage"
                className={isActive("/remplacement-elevage") ? "active-link" : ""}
              >
                Remplacement d’élevage/pension
              </NavDropdown.Item>
              <NavDropdown.Item
                href="/bilan-comportemental-chiens-chats"
                className={isActive("/bilan-comportemental-chiens-chats") ? "active-link" : ""}
              >
                Bilan comportemental
              </NavDropdown.Item>
              <NavDropdown.Item
                href="/cours-education-chiens-chats"
                className={isActive("/cours-education-chiens-chats") ? "active-link" : ""}
              >
                Cours d’éducation
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link
              href="/a-propos"
              className={isActive("/a-propos") ? "active-link" : "text-light"}
            >
              À propos de moi
            </Nav.Link>
            <Nav.Link
              href="/partenaires"
              className={isActive("/partenaires") ? "active-link" : "text-light"}
            >
              Mes partenaires
            </Nav.Link>
            <Nav.Link
              href="#contact"
              className="text-light"
            >
              Me contacter
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;